<!--some pixels of padding to show box shadow, otherwise it's cut-off by container -->
<div class="space-y-md p-px pb-[3px]" *transloco="let t">
  <ng-content select="[content=heading]"></ng-content>
  <cft-filter-bar [showClear]="!!this.filter$.value.location" (clear)="clearLocationFilters()">
    <cft-filter
      #locationFilter
      [placeholder]="t('proDirectory.locationFilter.placeholder')"
      [optionsProvider]="searchPostCode.bind(this)"
      (filterChanged)="locationFilterChanged($event)"
      [defaultOption]="defaultGeoValue()"
      [icon]="locationIcon"
      data-testid="location-filter"
    ></cft-filter>
    <!-- location filter only available after selecting a postal code, and is unavailable overall with regions -->
    <cft-filter
      #distanceFilter
      [class.hidden!]="!this.filter$.value.location?.zip || this.filter$.value.region"
      [searchDisabled]="true"
      [icon]="distanceIcon"
      [defaultOption]="distanceDefaultOption"
      [options]="distanceOptions"
      (filterChanged)="distanceFilterChanged($event)"
      data-testid="distance-filter"
    ></cft-filter>
  </cft-filter-bar>
  <cft-sorting-bar>
    @if (canSort && this.proDirectory?.pros?.length) {
      <cft-sorting (sortingChanged)="sortBy($event)" [options]="sortingOptions"></cft-sorting>
    } @else {
      <div class="px-xs py-2xs">
        {{ proDirectory?.pros?.length ? t('proDirectory.sortBy.relevance') : t('proDirectory.sortBy.notPossible') }}
      </div>
    }
  </cft-sorting-bar>
  @if (proDirectory && proDirectory.pros.length) {
    <ul class="space-y-sm">
      @for (pro of proDirectory.pros; track pro.id) {
        <li>
          <bgo-pro-directory-card (navigated)="navigate()" [pro]="pro"></bgo-pro-directory-card>
        </li>
      }
    </ul>
  } @else {
    <div class="mx-auto flex max-w-(--container-xl) flex-col gap-lg">
      <div class="py-2xl">
        <cft-message [icon]="infoIcon" [title]="t('proDirectory.noResults.title', {industry: title})">
          {{ t('proDirectory.noResults.message') }}
        </cft-message>
      </div>
      <div>
        <h3 class="mb-lg heading-lg">{{ t('proDirectory.otherOptions.title') }}</h3>
        <ul class="flex flex-col gap-md">
          <li class="">
            <a (click)="navigate()" [routerLink]="linkService.localizedPathTo(otherJobRequestRoute)">
              <cft-horizontal-list-card
                elevation="elevated"
                [isMultiLine]="true"
                [title]="t('proDirectory.otherOptions.card1.title')"
                [description]="t('proDirectory.otherOptions.card1.message')"
              ></cft-horizontal-list-card>
            </a>
          </li>
          <li class="">
            <cft-horizontal-list-card
              bgoOpenContactModal
              [dataPrivacyLink]="dataPrivacyLink"
              [contactForm]="contactForm"
              elevation="elevated"
              [isMultiLine]="true"
              [title]="t('proDirectory.otherOptions.card2.title')"
              [description]="t('proDirectory.otherOptions.card2.message')"
            ></cft-horizontal-list-card>
          </li>
          <li class="">
            <cft-horizontal-list-card
              bgoOpenContactModal
              [dataPrivacyLink]="dataPrivacyLink"
              [contactForm]="contactForm"
              elevation="elevated"
              [isMultiLine]="true"
              [title]="t('proDirectory.otherOptions.card3.title')"
              [description]="t('proDirectory.otherOptions.card3.message')"
            ></cft-horizontal-list-card>
          </li>
        </ul>
      </div>
    </div>
  }

  @if (proDirectory && proDirectory.total > proDirectory.pros.length) {
    <div class="text-center">
      <button
        cft-button
        class="btn btn-secondary"
        [isLoading$]="proDirectoryIsLoading$"
        (click)="loadMoreDirectoryPros()"
        type="button"
      >
        {{ t('proDirectory.showMoreButton') }}
      </button>
    </div>
  }
</div>
